module.exports = __webpack_public_path__ + "img/icons_Marketing_resources.edfa329d.svg";